// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"639":"046e25ef55f06e49","782":"501dd3034233930e"}[chunkId] + ".css";
};